import React, { useEffect, useState } from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import $image_url from 'js/utils/image_url';
import { get } from 'js/utils/api_utils';

import { Navbar, LinkItem } from 'js/design_system/nav/Navbar';

const Logo = styled.a`
  padding: 8px;
`;

const AcademiaLogo = () => (
  <Logo href={routes.home_url({ source: 'about-top-nav' })}>
    <img src={$image_url('/images/design_system/academia_logo_black.svg')} />
  </Logo>
);

type AboutHiringNavbarProps = {
  messages_count: number | null;
};

const AboutHiringNavbar: React.FC<AboutHiringNavbarProps> = ({
  messages_count,
}) => {
  const [unreadMentionsCount, setUnreadMentionsCount] = useState(0);

  useEffect(() => {
    const url = routes.unread_count_api_v0_mentions_path({
      subdomain_param: 'api',
    });
    get(url).then(({ count }) => setUnreadMentionsCount(count));
  }, []);

  return (
    <Navbar
      logoSmall={<AcademiaLogo />}
      logoLarge={<AcademiaLogo />}
      messagesCount={messages_count}
      unreadMentionsCount={unreadMentionsCount}
      items={
        <>
          <LinkItem
            href={routes.about_url({
              source: 'about-top-nav',
            })}
          >
            About Academia
          </LinkItem>
          <LinkItem
            href={routes.hiring_url({
              source: 'about-top-nav',
            })}
          >
            Careers
          </LinkItem>
        </>
      }
    />
  );
};

export default AboutHiringNavbar;
